// src/pages/FeedbackManagementPage.jsx
import React, { useEffect, useState } from "react";

function FeedbackManagementPage() {
    const [feedback, setFeedback] = useState([]);

    useEffect(() => {
        // Example: fetch from a real API
        // fetch("/api/feedback")
        //   .then(res => res.json())
        //   .then(data => setFeedback(data));

        // Mock data for demo
        setFeedback([
            {
                id: 1,
                user: "Adam",
                comment: "Great product!",
                date: "2024-12-23",
                status: "new",
            },
            {
                id: 2,
                user: "Eve",
                comment: "Found a bug in the login process.",
                date: "2024-12-22",
                status: "reviewed",
            },
            {
                id: 3,
                user: "Bob",
                comment: "Can we have dark mode?",
                date: "2024-12-21",
                status: "new",
            },
        ]);
    }, []);

    return (
        <div>
            <h1 className="text-2xl font-bold mb-4">Feedback Management</h1>
            <div className="bg-white rounded shadow p-4">
                <table className="w-full">
                    <thead>
                        <tr className="border-b">
                            <th className="p-2 text-left">ID</th>
                            <th className="p-2 text-left">User</th>
                            <th className="p-2 text-left">Comment</th>
                            <th className="p-2 text-left">Date</th>
                            <th className="p-2 text-left">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {feedback.map((item) => (
                            <tr
                                key={item.id}
                                className="border-b hover:bg-gray-50">
                                <td className="p-2">{item.id}</td>
                                <td className="p-2">{item.user}</td>
                                <td className="p-2">{item.comment}</td>
                                <td className="p-2">{item.date}</td>
                                <td className="p-2">{item.status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default FeedbackManagementPage;
